import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { AssignmentType } from '@axo/shared/data-access/types/ace';
import { MarketCountryCode } from '@axo/shared/data-access/types/ace_index';

export function useAgents(params: {
  marketCountry?: string;
  assignmentType?: AssignmentType;
}) {
  const api = useAPI();

  return useQuery({
    queryKey: ['agents', params.marketCountry, params.assignmentType],
    queryFn: () =>
      ace_api.findAgents(api)({
        market_country: params.marketCountry as MarketCountryCode,
        assignment_type: params.assignmentType,
      }),
    enabled: !!params.marketCountry && api.token !== '',
  });
}
